import React from "react";

const Benefits = () => {
  return (
    <div className="pbo-benefits-wrapper">
      <h1>
        Benefits of <span>Project</span> Based Outsourcing
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Cost-effective project management with reduced overhead</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Access to specialized talent and cutting-edge technology</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Accelerated project delivery without compromising quality</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Reduced workload for in-house teams</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
